import React from 'react';
import { useSelector } from '../redux/store';
import { inviteLinkRoot } from '../utils/link';

export default function useInviteLink() {
  const slug = useSelector((state) => state.publicConfig?.slug);
  return `${inviteLinkRoot}/r/${slug}`;
}
